// =============================================================================
// Normascan — Plateforme d'analyse normative par IA
// Copyright (c) 2026-2027 Evalens SAS — Tous droits réservés
// Marque Normascan déposée INPI n°5242986 (classes 9 et 42)
// Site : https://app.normascan.fr
// =============================================================================
import React from 'react';

const SkeletonRows = ({ cols = 5, rows = 6 }) => {
  const widths = ['60%', '40%', '80%', '50%', '70%', '45%', '65%'];
  return (
    <>
      <style>{`
        @keyframes shimmer {
          0% { background-position: -400px 0; }
          100% { background-position: 400px 0; }
        }
        .skeleton-cell {
          height: 14px; border-radius: 6px;
          background: linear-gradient(90deg, var(--gray) 25%, rgba(128,128,128,0.15) 50%, var(--gray) 75%);
          background-size: 400px 100%;
          animation: shimmer 1.4s infinite;
        }
      `}</style>
      {Array.from({ length: rows }).map((_, ri) => (
        <tr key={ri} style={{ borderBottom: '1px solid var(--gray)' }}>
          {Array.from({ length: cols }).map((_, ci) => (
            <td key={ci} style={{ padding: '12px 14px' }}>
              <div className="skeleton-cell" style={{ width: widths[(ri + ci) % widths.length] }} />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};

export default SkeletonRows;